import styled from "@emotion/styled"
import { NavLink } from "react-router-dom"

export const StyledNavLink = styled(NavLink)`
  flex: 1;
  text-decoration: none;
`
